export default __webpack_public_path__ + "static/media/FurJaden.f8ff753c.jpg";